import ErrorBoundary from './components/ErrorBoundary';
import ThemeProviders from './ThemeProviders';
import Providers from './Providers';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <ThemeProviders>
      <ErrorBoundary>
        <Providers>
          <AppRoutes />
        </Providers>
      </ErrorBoundary>
    </ThemeProviders>
  );
}

export default App;
